import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { parseString } from 'xml2js';

import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class XmlHttpService {
  protected constructor(private http: HttpClient, private configService: ConfigService) {}

  public get(url: string): Observable<any> {
    return this.http
      .get(
        `${this.configService.config.apiUrl}${url}${url.includes('?') ? '&' : '?'}key=${
          this.configService.config.apiKey
        }`,
        { responseType: 'text' },
      )
      .pipe(switchMap((xmlString: string) => this.handleXmlResult(xmlString)));
  }

  public post(url: string, body: any): Observable<any> {
    return this.http
      .post(
        `${this.configService.config.apiUrl}${url}`,
        { key: this.configService.config.apiKey, ...body },
        { responseType: 'json' },
      )
      .pipe(switchMap((json: any) => this.handleJsonResult(json)));
  }

  public put(url: string, body: any): Observable<any> {
    return this.http
      .put(
        `${this.configService.config.apiUrl}${url}`,
        { key: this.configService.config.apiKey, ...body },
        { responseType: 'text' },
      )
      .pipe(switchMap((json: any) => this.handleJsonResult(json)));
  }

  public delete(url: string): Observable<any> {
    return this.http
      .delete(
        `${this.configService.config.apiUrl}${url}${url.includes('?') ? '&' : '?'}key=${
          this.configService.config.apiKey
        }`,
        { responseType: 'text' },
      )
      .pipe(switchMap((xmlString: string) => this.handleXmlResult(xmlString)));
  }

  private handleXmlResult(xmlString: string) {
    return new Promise((resolve, reject) =>
      parseString(xmlString, (err, result) => {
        let hasError = !!err;
        let errorMessage: string;
        for (const prop in result) {
          if (result[prop]?.['Success']?.[0] === 'false') {
            hasError = true;
            errorMessage = result[prop]?.['ErrorMessage']?.[0];
          }
        }
        if (hasError) {
          reject(err ?? errorMessage);
        } else {
          resolve(result);
        }
      }),
    );
  }

  private handleJsonResult(json: any) {
    return new Promise((resolve, reject) => {
      const result = json.d;
      if (result.Success === false) {
        reject(result.ErrorMessage);
      } else {
        resolve(result);
      }
    });
  }
}
